import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useSelector } from "react-redux";
import Alerts from "./Alerts/Alerts";
import Reports from "./Reports/Reports";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function RightPane(props) {
  const overviewstate = useSelector(
    (state) => state.mainpagedata.overviewbarstate,
  );
  const [value, setValue] = useState("Alerts");
  const [pagesize, setPagesize] = useState(378);

  const handleChange = (event, newValue) => {
    console.log("newValue ", newValue);
    setValue(newValue);
  };

  useEffect(() => {
    //console.log("overviewstate ",overviewstate)
    if (overviewstate) {
      setPagesize(291);
    } else {
      setPagesize(256);
    }
  }, [overviewstate]);

  //const height = props.expanded ? 820 : 715;
  //const top = props.expanded ? 240 : 350;
  const { PermissionsArray: usrPrmns } = useSelector(
    (state) => state.logindata.userdetails,
  );
  return (
    <Box
      sx={{
        width: "278px",
        marginLeft: "16px",
        borderRadius: "0px 0px 0px 0px",
      }}
    >
      <Tabs
        // variant="scrollable"
        // scrollButtons
        value={value}
        onChange={handleChange}
        aria-label="basic tabs example"
        sx={{
          "& .MuiTabs-indicator": {
            height: "0px",
            borderRadius: "0px",
            backgroundColor: "var(--action-button-light)",
            backgroundColor: "var(--SecondaryBackground)",
          },
          "& .Mui-selected": {
            color: "var(--LK_BrandBlue_1) !important",
            fontWeight: "700 !important",
            backgroundColor: "var(--SecondaryBackground)",
            borderTop: "1px solid var(--HighlightedText_Stroke)",
            borderLeft: "1px solid var(--HighlightedText_Stroke)",
            borderRight: "1px solid var(--HighlightedText_Stroke)",
            borderBottom: "1px solid var(--SecondaryBackground)",
          },
          "& .MuiTab-root": {
            padding: "0px !important",
            margin: "0px !important",
            minWidth: "63px",
          },
          minHeight: "30px",
          marginBottom: "-1px",
        }}
      >
        <Tab
          label="Alerts"
          value="Alerts"
          {...a11yProps(0)}
          sx={{
            minHeight: "30px",
            height: "30px",
          }}
          style={{
            color: "var(--GreyVariation_2)",
            fontFamily: "Roboto",
            fontSize: "14px",
            fontWeight: 400,
            lineHeight: "16.41px",
            textTransform: "capitalize",
          }}
        />
        <Tab
          label="Reports"
          value="Reports"
          {...a11yProps(1)}
          sx={{
            minHeight: "30px",
            height: "30px",
          }}
          style={{
            color: "var(--GreyVariation_2)",
            fontFamily: "Roboto",
            fontSize: "14px",
            fontWeight: 400,
            lineHeight: "16.41px",
            textTransform: "capitalize",
          }}
        />
      </Tabs>
      <Box
        style={{
          width: "276px",
          height: `calc(100vh - ${pagesize}px)`,
          backgroundColor: "var(--SecondaryBackground)",
          borderRadius: "0px 0px 0px 0px",
          overflow: "auto",
          border: "1px solid var(--HighlightedText_Stroke)",
        }}
      >
        {Array.isArray(usrPrmns) &&
          usrPrmns.length > 0 &&
          usrPrmns.includes("PALV67") &&
          value === "Alerts" && <Alerts />}
        {Array.isArray(usrPrmns) &&
          usrPrmns.length > 0 &&
          usrPrmns.includes("PRGN60") &&
          value === "Reports" && <Reports />}
      </Box>
    </Box>
  );
}

/*
{value === 'Alarms' && <Alarms />}
                {value === 'Reports' && <Reports />}
<CustomTabPanel value={value} index={0} >
    <Box style={{ height: `calc(100% - 100px)`}}>
        <Alarms />
    </Box>
    
</CustomTabPanel>
<CustomTabPanel value={value} index={1}>
    <Reports/>
</CustomTabPanel>
<CustomTabPanel value={value} index={2}>

</CustomTabPanel>
<CustomTabPanel value={value} index={3}>

</CustomTabPanel>
*/
